@if (rollback === null) {
  <div
    class="notification"
  [ngClass]="{
    unfollowed: !notification.followed,
    link: !!notification.link,
  }"
    (mouseenter)="onHover()"
    (mouseleave)="onLeave()"
    >
    <a [href]="notification.link" [target]="target" (click)="clickNotification()">
      <div class="notification-container">
        <div class="new-indicator-container">
          @if (!notification.viewed) {
            <div class="new-indicator"></div>
          }
        </div>
        <div class="notification-body">
          <div>
            <span [innerHTML]="body"></span>
          </div>
          <div class="footer">
            <div class="event-time">{{ relativeTime }}</div>
            @if (getDisplayContext() && showContext) {
              <atlas-chip
                [style.background-color]="getColorForValue(getDisplayContext())"
                >
                {{ getDisplayContext() }}
              </atlas-chip>
            }
          </div>
        </div>
      </div>
    </a>
    <button mat-icon-button color="primary" [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      @if (notification.followed) {
        <button mat-menu-item (click)="markAsUnread()">
          {{ 'NOTIFICATIONS.ACTIONS.MARK_AS_UNREAD' | translate }}
        </button>
      }
      @if (!notification.followed) {
        <button mat-menu-item (click)="markAsRead()">
          {{ 'NOTIFICATIONS.ACTIONS.MARK_AS_READ' | translate }}
        </button>
      }
      @if (!!setting) {
        @if (setting.status === SubscriptionStatus.NOTIFICATION_STATUS_ENABLED) {
          <button
            mat-menu-item
            (click)="unsubscribeFrom()"
            >
            {{ 'NOTIFICATIONS.ACTIONS.TURN_OFF_NOTIFICATION' | translate }}
          </button>
        }
        @if (setting.status === SubscriptionStatus.NOTIFICATION_STATUS_DISABLED) {
          <button
            mat-menu-item
            (click)="subscribeTo()"
            >
            {{ 'NOTIFICATIONS.ACTIONS.TURN_ON_NOTIFICATION' | translate }}
          </button>
        }
      }
    </mat-menu>
  </div>
}

@if (rollback !== null) {
  <div class="unsubscribe notification-container">
    @if (rollback === 'subscribe') {
      <div class="undo-body">
        {{ 'NOTIFICATIONS.UNSUBSCRIBE_TEXT' | translate }}
      </div>
    }
    @if (rollback === 'unsubscribe') {
      <div class="undo-body">
        {{ 'NOTIFICATIONS.SUBSCRIBE_TEXT' | translate }}
      </div>
    }
    <div class="undo">
      <atlas-button (onClick)="emitUndo()" class="undo-button" [raised]="true">
        {{ 'NOTIFICATIONS.ACTIONS.UNDO' | translate }}
      </atlas-button>
    </div>
  </div>
}
